<template>
  <div class="container">
    <div class="mb-3">
      <label for="name" class="form-label"> <i class="requiredFields">*</i> Nombres y apellidos completos:</label>
      <input v-model="fullname" type="text" class="form-control" id="name" />
    </div>
    <div class="mb-3">
      <label for="userName" class="form-label"> <i class="requiredFields">*</i> Nombre de usuario:</label>
      <input v-model="username" type="text" class="form-control" id="userName" placeholder="Ejemplo: MElviraRuiz1" />
      <div id="userNameHelp" class="form-text txtHelp me-4">
        El nombre de usuario debe contar con al menos 8 carácteres e incluir una letra mayúscula y un
        número.
      </div>
    </div>
    <div class="mb-3">
      <label for="jobRole" class="form-label"> <i class="requiredFields">*</i> Seleccione el rol de trabajo:</label>
      <select class="form-select" v-model="roles">
        <option selected>Seleccione una de las opciones...</option>
        <option value='3'>
          Asesor Comercial y Compras a Provedores.
        </option>
        <option value='2'>
          Asesor Tecnológico y Sistemas Digitales.
        </option>
        <option value='1'>Administrador del Sistema.</option>
      </select>
    </div>
    <label for="password" class="form-label"><i class="requiredFields">*</i> Contraseña:</label>
    <div class="input-group mb-3">
      <input class="form-control" id="password" v-model="password" :type="showPassword ? 'text' : 'password'" />
      <span class="input-group-text" id="basic-addon2">
        <svg v-show="hidePassIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
          class="bi bi-eye-slash-fill mt-1" viewBox="0 0 16 16" :class="{ 'bi-eye-slash': !showPassword }"
          @click="togglePasswordVisibility">
          <path
            d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
          <path
            d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
        </svg>
        <svg v-show="showPassIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
          class="bi bi-eye-fill mt-1" viewBox="0 0 16 16" :class="{ 'bi-eye-slash': showPassword }"
          @click="togglePasswordVisibility2">
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
        </svg>
      </span>
    </div>
    <div id="passwordHelp" class="form-text txtHelp me-4">
      La contraseña debe ser de mínimo 8 carácteres e incluir al menos una letra mayúscula, un número y
      un carácter especial <i>(*,%,$,?,!,&).</i>
    </div>
    <div class="btnRegister">
      <button type="submit" class="btn btn-danger" @click.prevent="register">
        Registrar
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      //Password behavior
      showPassword: false,
      hidePassIcon: true,
      showPassIcon: false,
      //Fields
      fullname: "",
      username: "",
      password: "",
    };
  },
  methods: {
    async register() {
      if (this.username === "" || this.fullname === "" || this.password === "") {
        alert("Los campos estan vacios, complete aquellos que son obligatorios marcados con un *.")
      } else {
        if (this.validatePassword(this.password)) {
          let finalJobRole = this.loadValueRole(this.roles)
          //console.log(finalJobRole)
          //console.log("Call the function register");
          let formData = new FormData();
          formData.append("fullname", this.fullname);
          formData.append("username", this.username);
          formData.append("roles", finalJobRole);
          formData.append("password", this.password);
          try {
            let res = await axios.post(
              RUTA_SERVIDOR + "api/user/create",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );
            console.log(res.data);
            if (!res.data) {
              console.log("There has been a different error with the data.");
            } else {
              alert('Bien hecho!, se ha creado el usuario con exito.');
              this.$router.push("/")
              //this.$router.push("/Families");
              //Sesion storage
            }
          } catch (err) {
            console.log(`There has been an error ${err}`);
          }
        } else {
          alert("La contraseña proporcionada no cumple con los requisitos.");
          this.password = "";
        }
      }
    },
    loadValueRole(roleId) {
      let arraySimple = [];
      if (roleId == 1 || roleId == 2) {
        arraySimple.push('ROLE_ADMIN')
      } else if (roleId == 3) {
        arraySimple.push('ROLE_SELLER')
      } else {
        console.log('Invalid job role')
      }
      return JSON.stringify(arraySimple);
    },
    validatePassword(password) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,15}[^'\s]/;
      return regex.test(password);
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.showPassIcon = true;
      this.hidePassIcon = false;
    },
    togglePasswordVisibility2() {
      this.showPassword = false;
      this.showPassIcon = false;
      this.hidePassIcon = true;
    },

  },
};
</script>
<style scoped>
.btnRegister {
  text-align: center;
}

.txtHelp {
  text-align: end;
  font-style: italic;
}

@media screen and (max-width: 500px) {
  form {
    width: 100% !important;
  }

  label {
    margin-left: 25px;
  }

  input {
    margin: auto;
    width: 90% !important;
  }

  select {
    margin: auto;
    width: 90% !important;
  }
}

.requiredFields {
  color: #9d0e15;
}
</style>
